module.exports = "<a class=\"btn btn-success btn-modal-ok pull-right\"><%= translatedStrings['1622156b-06fe-4daa-a0fb-fac7bec73211'] %></a>";